import { useCallback, useEffect, useState } from 'react';

import { postMessageToMobileApp } from 'components/app/helpers';
import { IS_RN_WEBVIEW_IOS } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { addLogsToSentry } from 'helpers/sentry';

const ERROR_MSG = {
  PERMISSION_NOT_GRANTED: 'Camera permissions is not granted.',
  BROWSER_NOT_SUPPORTED: 'getUserMedia not supported in this browser.',
};

const useCameraPermissions = ({ askOnMount = true }: { askOnMount: boolean }) => {
  const [permissionGranted, setPermissionGranted] = useState(false);

  const askCameraPermissions = useCallback(() => {
    if (IS_RN_WEBVIEW_IOS) {
      postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.CAMERA_PERMISSION);
      return;
    }
    if (navigator?.mediaDevices?.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(() => {
          setPermissionGranted(true);
        })
        .catch(error => {
          setPermissionGranted(false);
          addLogsToSentry({ error: error?.toString() }, ERROR_MSG.PERMISSION_NOT_GRANTED);
        });
    } else {
      setPermissionGranted(false);
      addLogsToSentry({}, ERROR_MSG.BROWSER_NOT_SUPPORTED);
    }
  }, []);

  useEffect(() => {
    if (askOnMount) {
      askCameraPermissions();
    }
  }, [askCameraPermissions, askOnMount]);

  return { permissionGranted, askCameraPermissions };
};

export default useCameraPermissions;
